export const environment = {
  apiBaseUrl: "https://answering-service.catvante.com.br/",
  baseUrl: "https://plataforma.catvante.com.br",
  feedbackBaseUrl: "https://devolutiva.catvante.com.br/",
  auth: {
    baseUrl: "https://auth.catvante.com.br",
    redirectUrl: "https://plataforma.catvante.com.br/auth",
    clientId: "catvante_answering"
  }
}
